import { render, staticRenderFns } from "./representive.vue?vue&type=template&id=67a433f7&"
import script from "./representive.vue?vue&type=script&lang=js&"
export * from "./representive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports